import { Member, User } from '@quick/client';
import { identifyIntercom, resetIntercom } from '../analytics/intercom';
import { identifySegment, resetSegment } from '../analytics/segment';
import { identifySmartlook, resetSmartlook } from '../analytics/smartlook';
import { identifySentry, resetSentry } from '../analytics/sentry';
import { useDeepCompareEffect } from 'react-use';
import { useCurrentMember, useCurrentUser } from '../redux/selector';
import { useIdentifyLaunchdarkly, useResetLaunchdarkly } from './featureflags/launchdarkly';

export const useIdentifyCurrentUserAndMemberIfNeeded = () => {
  const member = useCurrentMember();
  const user = useCurrentUser()!;
  const identifyUser = useIdentifyUser();
  useDeepCompareEffect(() => {
    identifyUser(user, member);
  }, [member, user]);
};

const useIdentifyUser = () => {
  const identifyLaunchdarkly = useIdentifyLaunchdarkly();
  return async (user: User, member: Member | undefined) => {
    try {
      await Promise.all([
        identifyLaunchdarkly(user, member),
        identifyIntercom(user, member),
        identifySegment(user, member),
        identifySmartlook(user, member),
        identifySentry(user, member),
      ]);
    } catch (e) {}
  };
};

export const useResetUser = () => {
  const resetLaunchdarkly = useResetLaunchdarkly();
  return async () => {
    try {
      return Promise.all([resetLaunchdarkly(), resetSegment(), resetIntercom(), resetSmartlook(), resetSentry()]);
    } catch (e) {}
  };
};
